module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_02@2x-3c073284b6320386ca4d9bdabb8e665c.jpg";